import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-743981a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex__column--center" }
const _hoisted_2 = { class: "ecran-container" }
const _hoisted_3 = { class: "div__product--img" }
const _hoisted_4 = { class: "app__title--medium" }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { style: {"max-width":"12rem","align-items":"center","justify-content":"center","margin":"1rem auto 0 auto"} }
const _hoisted_9 = {
  key: 0,
  class: "ecran__details",
  style: {"position":"relative"}
}
const _hoisted_10 = { class: "ecran__sizes" }
const _hoisted_11 = { class: "app__label--medium text-weight-bold" }
const _hoisted_12 = { class: "card__dimensiuni" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "app__label--medium text-weight-bold" }
const _hoisted_15 = { class: "card__dimensiuni" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "app__label--medium text-weight-bold" }
const _hoisted_18 = { class: "card__dimensiuni" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "app__label--medium text-weight-bold" }
const _hoisted_21 = { class: "card__dimensiuni" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "app__label--medium text-weight-bold" }
const _hoisted_24 = { class: "card__dimensiuni" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "app__label--medium text-weight-bold" }
const _hoisted_27 = { class: "card__dimensiuni" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "app__label--medium text-weight-bold" }
const _hoisted_30 = { class: "card__dimensiuni" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "app__label--medium text-weight-bold" }
const _hoisted_33 = { class: "card__dimensiuni" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { style: {"grid-area":"toggledebit"} }
const _hoisted_36 = {
  key: 0,
  class: "cutting-length-width",
  style: {"grid-area":"lungimelatime"}
}
const _hoisted_37 = { style: {"font-weight":"bold","font-size":"1.2rem"} }
const _hoisted_38 = { style: {"font-weight":"bold","font-size":"1.2rem"} }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { style: {"grid-area":"nrbuc"} }
const _hoisted_42 = { style: {"font-weight":"bold","font-size":"1.2rem"} }
const _hoisted_43 = { style: {"display":"flex","justify-content":"flex-start","padding-top":"2rem","padding-bottom":"2rem","padding-right":"2rem","min-height":"7rem"} }
const _hoisted_44 = { style: {"font-weight":"bold","font-size":"1.2rem"} }
const _hoisted_45 = { style: {"font-weight":"bold","font-size":"1.2rem"} }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = {
  key: 2,
  style: {"margin-left":"24px","margin-top":"-20px"}
}
const _hoisted_48 = { style: {"text-align":"center","display":"flex","align-items":"center"} }
const _hoisted_49 = { style: {"display":"flex","flex-direction":"row"} }
const _hoisted_50 = {
  key: 0,
  style: {"display":"flex","flex-direction":"column","align-items":"center"}
}
const _hoisted_51 = {
  key: 1,
  style: {"display":"flex","flex-direction":"column","align-items":"center"}
}
const _hoisted_52 = {
  key: 1,
  class: "text-negative",
  style: {"padding-bottom":"1rem"}
}
const _hoisted_53 = {
  key: 2,
  style: {"display":"flex","align-items":"center","gap":"8px"}
}
const _hoisted_54 = { style: {"font-size":"1rem"} }
const _hoisted_55 = { key: 3 }
const _hoisted_56 = { style: {"color":"red"} }
const _hoisted_57 = { style: {"display":"flex","justify-content":"center","padding-top":"2rem","padding-bottom":"2rem"} }
const _hoisted_58 = { style: {"display":"flex","flex-direction":"column","padding-top":"2rem","padding-bottom":"2rem","padding-right":"2rem"} }
const _hoisted_59 = { class: "app__label--medium" }
const _hoisted_60 = {
  key: 1,
  class: "app__label--medium"
}
const _hoisted_61 = {
  key: 1,
  class: "app__title--small"
}
const _hoisted_62 = { style: {"color":"black","font-weight":"900"} }
const _hoisted_63 = {
  key: 2,
  class: "app__title--small"
}
const _hoisted_64 = { style: {"color":"black","font-weight":"900"} }
const _hoisted_65 = { style: {"display":"flex","flex-direction":"column"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HierarchicalChainBrowseHeader = _resolveComponent("HierarchicalChainBrowseHeader")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_circular_progress = _resolveComponent("q-circular-progress")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_HierarchicalChainBrowseHeader, {
      hierarchicalChain: _ctx.paramArticles.hierarchicalChain
    }, null, 8, ["hierarchicalChain"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$i18n.locale === 'ro' ? _ctx.paramArticles.categoryNameRO : _ctx.$i18n.locale === 'en' ? _ctx.paramArticles.categoryNameEN : _ctx.paramArticles.categoryNameBG), 1),
          _createVNode(_component_q_img, {
            src: _ctx.urlToJPG+'/'+_ctx.pidCategory,
            class: "category__img",
            fit: "scale-down",
            ratio: "1"
          }, null, 8, ["src"]),
          (_ctx.existaArticole)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 0,
                outline: "",
                dense: "",
                color: "blue",
                "no-caps": "",
                style: {"max-width":"12rem","margin":"1rem auto 0 auto"},
                onClick: _ctx.toggleArticleInFavorites
              }, {
                default: _withCtx(() => [
                  (_ctx.articleIsOnFavorites)
                    ? (_openBlock(), _createBlock(_component_q_icon, {
                        key: 0,
                        left: "",
                        size: "1.3rem",
                        name: "favorite",
                        color: "red"
                      }))
                    : (_openBlock(), _createBlock(_component_q_icon, {
                        key: 1,
                        left: "",
                        size: "1.2rem",
                        name: "favorite_border",
                        color: "red"
                      })),
                  (_ctx.articleIsOnFavorites)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('message.added_to_favorites')), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('message.add_to_favorite')), 1))
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('message.article_not_found')), 1)
        ]),
        (_ctx.existaArticole)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_ctx.paramArticles.withWidth=='y' )
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      style: _normalizeStyle([{"padding-top":"1rem"}, { order: _ctx.paramArticles.positionWidth }])
                    }, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('message.width')), 1),
                      _createElementVNode("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramArticles.arrWidth, (size) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: size,
                            class: _normalizeClass(["card__dimensiuni--item", { 'card__dimensiuni--item--available': _ctx.isWidthAvailable(size),'card__dimensiuni--item--selected':_ctx.selectedWidth==size  }]),
                            onClick: ($event: any) => (_ctx.setSize('w',size))
                          }, _toDisplayString(size), 11, _hoisted_13))
                        }), 128))
                      ])
                    ], 4))
                  : _createCommentVNode("", true),
                (_ctx.paramArticles.withThickness=='y')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      style: _normalizeStyle([{"padding-top":"1rem"}, { order: _ctx.paramArticles.positionThickness }])
                    }, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('message.thickness')), 1),
                      _createElementVNode("div", _hoisted_15, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramArticles.arrThickness, (size) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: size,
                            class: _normalizeClass(["card__dimensiuni--item", { 'card__dimensiuni--item--available': _ctx.isThicknessAvailable(size),'card__dimensiuni--item--selected':_ctx.selectedThickness==size  }]),
                            onClick: ($event: any) => (_ctx.setSize('t',size))
                          }, _toDisplayString(size), 11, _hoisted_16))
                        }), 128))
                      ])
                    ], 4))
                  : _createCommentVNode("", true),
                (_ctx.paramArticles.withDiameter=='y')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      style: _normalizeStyle([{"padding-top":"1rem"}, { order: _ctx.paramArticles.positionDiameter }])
                    }, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('message.diameter')) + " (mm)", 1),
                      _createElementVNode("div", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramArticles.arrDiameter, (size) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: size,
                            class: _normalizeClass(["card__dimensiuni--item", { 'card__dimensiuni--item--available': _ctx.isDiameterAvailable(size),'card__dimensiuni--item--selected':_ctx.selectedDiameter==size  }]),
                            onClick: ($event: any) => (_ctx.setSize('d',size))
                          }, _toDisplayString(size), 11, _hoisted_19))
                        }), 128))
                      ])
                    ], 4))
                  : _createCommentVNode("", true),
                (_ctx.paramArticles.withHeight=='y')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      style: _normalizeStyle([{"padding-top":"1rem"}, { order: _ctx.paramArticles.positionHeight }])
                    }, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('message.height')), 1),
                      _createElementVNode("div", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramArticles.arrHeight, (size) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: size,
                            class: _normalizeClass(["card__dimensiuni--item", { 'card__dimensiuni--item--available': _ctx.isHeightAvailable(size),'card__dimensiuni--item--selected':_ctx.selectedHeight==size  }]),
                            onClick: ($event: any) => (_ctx.setSize('h',size))
                          }, _toDisplayString(size), 11, _hoisted_22))
                        }), 128))
                      ])
                    ], 4))
                  : _createCommentVNode("", true),
                (_ctx.paramArticles.withAlloy=='y')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      style: _normalizeStyle([{"padding-top":"1rem"}, { order: _ctx.paramArticles.positionAlloy }])
                    }, [
                      _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('message.aliaj')), 1),
                      _createElementVNode("div", _hoisted_24, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramArticles.arrAlloy, (size) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: size,
                            class: _normalizeClass(["card__dimensiuni--item", { 'card__dimensiuni--item--available': _ctx.isAlloyAvailable(size),'card__dimensiuni--item--selected':_ctx.selectedAlloy==size  }]),
                            onClick: ($event: any) => (_ctx.setSize('a',size))
                          }, _toDisplayString(size), 11, _hoisted_25))
                        }), 128))
                      ])
                    ], 4))
                  : _createCommentVNode("", true),
                (_ctx.paramArticles.withLength=='y')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 5,
                      style: _normalizeStyle([{"padding-top":"1rem"}, { order: _ctx.paramArticles.positionLength }])
                    }, [
                      _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('message.length')), 1),
                      _createElementVNode("div", _hoisted_27, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramArticles.arrLength, (size) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: size,
                            class: _normalizeClass(["card__dimensiuni--item", { 'card__dimensiuni--item--available': _ctx.isLengthAvailable(size),'card__dimensiuni--item--selected':_ctx.selectedLength==size }]),
                            onClick: ($event: any) => (_ctx.setSize('l',size))
                          }, _toDisplayString(size), 11, _hoisted_28))
                        }), 128))
                      ])
                    ], 4))
                  : _createCommentVNode("", true),
                (_ctx.paramArticles.withType=='y')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 6,
                      style: _normalizeStyle([{"padding-top":"1rem"}, { order: _ctx.paramArticles.positionType }])
                    }, [
                      _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('message.type')), 1),
                      _createElementVNode("div", _hoisted_30, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramArticles.arrType, (size, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: size,
                            class: _normalizeClass(["card__dimensiuni--item hover-div", { 'card__dimensiuni--item--available': _ctx.isTypeAvailable(size),'card__dimensiuni--item--selected':_ctx.selectedType==size }]),
                            onClick: ($event: any) => {_ctx.setSize('k',size); _ctx.showTipImages(_ctx.paramArticles.categoryPid, index, size)}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.typeLabel(size)) + " ", 1),
                            _createVNode(_component_q_tooltip, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('message.available_pictures')), 1)
                              ]),
                              _: 1
                            })
                          ], 10, _hoisted_31))
                        }), 128))
                      ])
                    ], 4))
                  : _createCommentVNode("", true),
                (_ctx.paramArticles.withRollWeight=='y')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 7,
                      style: _normalizeStyle([{"padding-top":"1rem"}, { order: _ctx.paramArticles.positionRollWeight }])
                    }, [
                      _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('message.roll_weight')), 1),
                      _createElementVNode("div", _hoisted_33, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramArticles.arrRollWeight, (size) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: size,
                            class: _normalizeClass(["card__dimensiuni--item", { 'card__dimensiuni--item--available': _ctx.isRollWeightAvailable(size),'card__dimensiuni--item--selected':_ctx.selectedRollWeight==size }]),
                            onClick: ($event: any) => (_ctx.setSize('g',size))
                          }, _toDisplayString(size), 11, _hoisted_34))
                        }), 128))
                      ])
                    ], 4))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.selectedSize.cuDebitare)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'card__debitare__options_mobile' : _ctx.typeOfArticle==='placa' ? 'card__debitare__options_placa' : 'card__debitare__options')
                  }, [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_q_toggle, {
                        modelValue: _ctx.dorescDebitare,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dorescDebitare) = $event)),
                          _ctx.punePeZeroDimensiuni
                        ],
                        label: _ctx.$t('message.want_cutting')
                      }, null, 8, ["modelValue", "label", "onUpdate:modelValue"])
                    ]),
                    (_ctx.selectedSize.cuDebitare && _ctx.dorescDebitare)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          (_ctx.typeOfArticle==='placa')
                            ? (_openBlock(), _createBlock(_component_q_input, {
                                key: 0,
                                modelValue: _ctx.cuttingWidth,
                                "onUpdate:modelValue": [
                                  _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cuttingWidth) = $event)),
                                  _ctx.coreleazaUm1Um2CuDebitare
                                ],
                                modelModifiers: { number: true },
                                type: "number",
                                min: "0",
                                max: "3020",
                                outlined: "",
                                "label-slot": "",
                                style: {"min-width":"15rem","max-width":"15rem"},
                                error: _ctx.ErrorRuleWidthDebitarePlaca
                              }, {
                                label: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('message.width')) + "(mm)", 1)
                                ]),
                                error: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.latimea_admisa_intre')) + " " + _toDisplayString(_ctx.minLengthPlaci) + "mm " + _toDisplayString(_ctx.$t('message.si')) + " " + _toDisplayString(_ctx.maxLengthPlaci) + "mm", 1)
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onUpdate:modelValue", "error"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_q_input, {
                            modelValue: _ctx.cuttingLength,
                            "onUpdate:modelValue": [
                              _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cuttingLength) = $event)),
                              _ctx.coreleazaUm1Um2CuDebitare
                            ],
                            modelModifiers: { number: true },
                            type: "number",
                            min: "0",
                            max: "3020",
                            outlined: "",
                            "label-slot": "",
                            style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'min-width:15rem; max-width: 15rem;' : 'min-width:15rem; max-width: 15rem;margin-left:1rem;'),
                            error: _ctx.ErrorRuleLengthDebitarePlaca
                          }, {
                            label: _withCtx(() => [
                              _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('message.length')) + "(mm)", 1)
                            ]),
                            error: _withCtx(() => [
                              (_ctx.typeOfArticle==='placa')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.$t('message.lungimea_adminsa_intre')) + " " + _toDisplayString(_ctx.minLengthPlaci) + "mm " + _toDisplayString(_ctx.$t('message.si')) + " " + _toDisplayString(_ctx.maxLengthPlaci) + "mm", 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.$t('message.lungimea_adminsa_intre')) + " " + _toDisplayString(_ctx.minLengthBare) + "mm " + _toDisplayString(_ctx.$t('message.si')) + " " + _toDisplayString(_ctx.maxLengthBare) + "mm", 1))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "style", "onUpdate:modelValue", "error"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_41, [
                      (_ctx.selectedSize.cuDebitare && _ctx.dorescDebitare)
                        ? (_openBlock(), _createBlock(_component_q_input, {
                            key: 0,
                            modelValue: _ctx.nrBucati,
                            "onUpdate:modelValue": [
                              _cache[3] || (_cache[3] = ($event: any) => ((_ctx.nrBucati) = $event)),
                              _ctx.coreleazaUm1Um2CuDebitare
                            ],
                            modelModifiers: { number: true },
                            type: "number",
                            outlined: "",
                            "label-slot": "",
                            min: "0",
                            max: "10000",
                            style: {"max-width":"7rem"}
                          }, {
                            label: _withCtx(() => [
                              _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t('message.nr_buc')), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_43, [
                (_ctx.selectedSize.um1 && _ctx.selectedSize.um1.length>0 && !_ctx.HideUm1IfBucDebit)
                  ? (_openBlock(), _createBlock(_component_q_input, {
                      key: 0,
                      modelValue: _ctx.qUm1Input,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => ((_ctx.qUm1Input) = $event)),
                        _cache[5] || (_cache[5] = ($event: any) => (_ctx.coreleazaUm1Um2('um1')))
                      ],
                      modelModifiers: { number: true },
                      type: "number",
                      readonly: (_ctx.selectedSize.cuDebitare && _ctx.dorescDebitare) || _ctx.ReadonlyKgForPlacaBara,
                      outlined: "",
                      "label-slot": "",
                      min: "0",
                      style: {"max-width":"7rem"}
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$umLabel(_ctx.selectedSize.um1)), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "readonly"]))
                  : _createCommentVNode("", true),
                (_ctx.selectedSize.um2 && _ctx.selectedSize.um2.length>0 && !_ctx.HideUm2IfBucDebit)
                  ? (_openBlock(), _createBlock(_component_q_input, {
                      key: 1,
                      modelValue: _ctx.qUm2,
                      "onUpdate:modelValue": [
                        _cache[6] || (_cache[6] = ($event: any) => ((_ctx.qUm2) = $event)),
                        _cache[7] || (_cache[7] = ($event: any) => (_ctx.coreleazaUm1Um2('um2')))
                      ],
                      modelModifiers: { number: true },
                      type: "number",
                      readonly: _ctx.selectedSize.cuDebitare && _ctx.dorescDebitare,
                      outlined: "",
                      "label-slot": "",
                      min: "0",
                      style: {"max-width":"7rem","margin-left":"1rem"},
                      error: _ctx.ErrorRuleIntegerNumberBuc || _ctx.ErrorRuleMultipleOfLength
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$umLabel(_ctx.selectedSize.um2)), 1)
                      ]),
                      error: _withCtx(() => [
                        (!_ctx.ErrorRuleMultipleOfLength)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.msjErrorRuleIntegerNumberBuc), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "readonly", "error"]))
                  : _createCommentVNode("", true),
                ((_ctx.selectedSize.um1 || _ctx.selectedSize.um2))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$t('message.tip_um_dorit_la_ofertare')), 1),
                      _createElementVNode("div", _hoisted_49, [
                        ((!_ctx.HideUm1IfBucDebit || _ctx.dorescDebitare) && (_ctx.selectedSize.um1 != '' && _ctx.selectedSize.um1 != null))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                              _createTextVNode(_toDisplayString(_ctx.$umLabel(_ctx.selectedSize.um1)) + " ", 1),
                              _createVNode(_component_q_checkbox, {
                                size: "xl",
                                modelValue: _ctx.selectedUM1,
                                "onUpdate:modelValue": [
                                  _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedUM1) = $event)),
                                  _cache[9] || (_cache[9] = val => _ctx.changeTipUm(val, 1))
                                ]
                              }, null, 8, ["modelValue"])
                            ]))
                          : _createCommentVNode("", true),
                        ((!_ctx.HideUm2IfBucDebit || _ctx.dorescDebitare) && (_ctx.selectedSize.um2 != '' && _ctx.selectedSize.um2 != null))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                              _createTextVNode(_toDisplayString(_ctx.$umLabel(_ctx.selectedSize.um2)) + " ", 1),
                              _createVNode(_component_q_checkbox, {
                                size: "xl",
                                modelValue: _ctx.selectedUM2,
                                "onUpdate:modelValue": [
                                  _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedUM2) = $event)),
                                  _cache[11] || (_cache[11] = val => _ctx.changeTipUm(val, 2))
                                ]
                              }, null, 8, ["modelValue"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.ErrorRuleMultipleOfLength)
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_ctx.$t('message.cantitatea_multiplu_de_lungime', { length: _ctx.SelectedLengthInMetres + ' ' + _ctx.$umLabel(_ctx.selectedSize.um2) })), 1))
                : _createCommentVNode("", true),
              ((_ctx.selectedSize.um1 || _ctx.selectedSize.um2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createElementVNode("span", _hoisted_54, [
                      _createTextVNode(_toDisplayString(_ctx.$t('message.status')) + ": ", 1),
                      _createElementVNode("b", null, _toDisplayString(_ctx.labelStock) + ".", 1)
                    ]),
                    (_ctx.loadingStock)
                      ? (_openBlock(), _createBlock(_component_q_circular_progress, {
                          key: 0,
                          indeterminate: "",
                          rounded: "",
                          size: "24px",
                          color: "black"
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isPlacaAluminiu=='1')
                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                    _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t('message.remarks_cutting')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_57, [
                (_ctx.labelBtnAdaugaBasket==='Adauga in cos')
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      color: (_ctx.articleCouldBePutInBasket?'amber-8':'amber-4'),
                      icon: "shopping_cart",
                      "no-caps": "",
                      label: _ctx.$t('message.add_in_basket'),
                      onClick: _ctx.addProductToBasket
                    }, null, 8, ["color", "label", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.labelBtnAdaugaBasket==='Adauga in cerere')
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      color: (_ctx.articleCouldBePutInBasket?'amber-8':'amber-4'),
                      icon: "shopping_cart",
                      "no-caps": "",
                      label: _ctx.$t('message.add_in_request'),
                      onClick: _ctx.addProductToCerere
                    }, null, 8, ["color", "label", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t('message.remarks')), 1),
                _createVNode(_component_q_input, {
                  maxlength: _ctx.selectedSize.cuDebitare && _ctx.dorescDebitare ? '20' : '200',
                  type: "textarea",
                  autogrow: "",
                  counter: "",
                  class: "input--desire",
                  outlined: "",
                  modelValue: _ctx.inputFreeTextComments,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.inputFreeTextComments) = $event)),
                  placeholder: _ctx.$t('message.write_something'),
                  dense: "",
                  color: "blue-grey-7"
                }, null, 8, ["maxlength", "modelValue", "placeholder"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_60, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('message.we_are_sorry')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('message.contact_sales_manager')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('message.thanks')), 1)
            ]))
      ]),
      _createVNode(_component_q_dialog, {
        modelValue: _ctx.isOpenDialogCategory,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.isOpenDialogCategory) = $event)),
        "transition-show": "fade-in",
        "transition-hide": "fade-out"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, { class: "bg-white" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_bar, { style: {"height":"46px","background-color":"#D8DCDF"} }, {
                default: _withCtx(() => [
                  (_ctx.$q.platform.is.mobile)
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        dense: "",
                        flat: "",
                        color: "blue",
                        align: "center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: "arrow_back_ios",
                            style: {"font-weight":"bold"}
                          })
                        ]),
                        _: 1
                      }, 512)), [
                        [_directive_close_popup]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.$q.platform.is.desktop)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                        _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.typeLabel(_ctx.labelTitle)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.$q.platform.is.mobile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                        _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.typeLabel(_ctx.labelTitle)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.$q.platform.is.desktop)
                    ? (_openBlock(), _createBlock(_component_q_space, {
                        key: 3,
                        dense: ""
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.$q.platform.is.desktop)
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        key: 4,
                        dense: "",
                        flat: "",
                        icon: "close",
                        color: "black"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, { "content-class": "bg-grey text-white" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('message.close')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 512)), [
                        [_directive_close_popup]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_scroll_area, {
                    style: {"height":"50vh","min-width":"300px","max-width":"clamp(100px,90vw, 600px)"},
                    visible: "",
                    "thumb-style": _ctx.thumbStyle,
                    "bar-style": _ctx.barStyle
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_65, [
                        (_ctx.ImgCategoryString641.length>0)
                          ? (_openBlock(), _createBlock(_component_q_img, {
                              key: 0,
                              src: _ctx.ImgCategoryString641,
                              "spinner-color": "primary",
                              style: {"min-width":"100px","max-width":"clamp(100px,90vw, 600px)","margin":"auto"}
                            }, {
                              loading: _withCtx(() => [
                                _createVNode(_component_q_spinner_gears, { color: "primary" })
                              ]),
                              _: 1
                            }, 8, ["src"]))
                          : _createCommentVNode("", true),
                        (_ctx.ImgCategoryString642.length>0)
                          ? (_openBlock(), _createBlock(_component_q_img, {
                              key: 1,
                              src: _ctx.ImgCategoryString642,
                              "spinner-color": "primary",
                              style: {"min-width":"100px","max-width":"clamp(100px,90vw, 600px)","margin":"auto"}
                            }, {
                              loading: _withCtx(() => [
                                _createVNode(_component_q_spinner_gears, { color: "primary" })
                              ]),
                              _: 1
                            }, 8, ["src"]))
                          : _createCommentVNode("", true),
                        (_ctx.ImgCategoryString643.length>0)
                          ? (_openBlock(), _createBlock(_component_q_img, {
                              key: 2,
                              src: _ctx.ImgCategoryString643,
                              "spinner-color": "primary",
                              style: {"min-width":"100px","max-width":"clamp(100px,90vw, 600px)","margin":"auto"}
                            }, {
                              loading: _withCtx(() => [
                                _createVNode(_component_q_spinner_gears, { color: "primary" })
                              ]),
                              _: 1
                            }, 8, ["src"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["thumb-style", "bar-style"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}